<template>
  <div class="home" :style="{minHeight: bodyHeight + 'px'}">
    <gHead2 />
    <div class="gContent" :style="{minHeight: (bodyHeight - 256) + 'px'}">
      <div class="login-box">
        <!-- <div class="login-box-entrance" v-if="isShow">
          <p style="color:#d13119;">观众登录</p>
          <p @click="linkToEx">展商登录</p>
        </div> -->
        <router-view></router-view>
      </div>
    </div>
    <gBottom />
  </div>
</template>

<script>
import config from "@assets/config.json";
import gHead2 from "@components/gHead2/gHead2.vue";
import gBottom from "@components/gBottom/gBottom.vue";
export default {
  name: "audience-login",
  data() {
    return {
      bodyHeight: "800px"
    };
  },
  components: {
    gHead2,
    gBottom,
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
    isShow() {
      let flag = true;
      if (this.$route.path.indexOf("register") !== -1) {
        flag = false;
      }
      return flag;
    }
  },
  created() {
    this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
    console.log(this.$route.path)
  },
  methods: {
    linkToEx() {
      window.open(`${config.BackendUrl}/exhibition/login/alogin`);
    }
  }
};
</script>
 
<style scoped lang="scss">
@import "@assets/scss/utils.scss";
.home {
  background: #fff;
}
.gContent {
  .login-box {
    width: 1200px;
    margin: 0 auto;
    &-entrance {
      width: 420px;
      padding: 0 44px;
      margin: 70px auto 0;
      display: flex;
      justify-content: space-between;
      p {
        height: 40px;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
}
.top-title {
  height: 50px;
  font-size: 14px;
  line-height: 35px;
  &-link {
    color: #999;
  }
}
.main {
  width: 1200px;
  margin-top: 20px;
  margin-bottom: 80px;
  @include clearfix;

  .section {
    width: 878px;
    border-radius: 2px;
    background-color: #fff;
    float: left;
    .section-top {
      // padding: 50px 65px;
      box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
      border-bottom: 20px solid #f5f5f5;
      .m-content {
        padding: 23px 60px 50px;
      }
    }
    .title {
      position: relative;
      padding-left: 20px;
      display: flex;
      align-items: center;
      height: 60px;
      border-bottom: 1px solid #f5f5f5;
      span {
        display: inline-block;
        width: 4px;
        height: 16px;
        background-color: #d13119;
      }
      h3 {
        display: inline-block;
        font-size: 16px;
        line-height: 18px;
        color: #333;
        margin-left: 15px;
      }
    }
  }

  .sidebar {
    width: 300px;
    float: right;
    @include empty-txt(200px, "加载中...");
  }
}

.m-info {
  height: 160px;
  background-color: #fff;
  padding: 20px;
  margin-top: 28px;
  &-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    // margin-bottom: 10px;
  }
  &-brand {
    display: flex;
    align-items: center;
    // margin-bottom: 6px;
    .brand {
      align-items: center;
      display: flex;
      margin-right: 15px;
      color: #999;
      span {
        font-size: 16px;
      }
      i {
        font-size: 22px;
      }
      .icon-chakan {
        font-size: 24px;
      }
    }
  }
  &-line {
    margin-right: 10px;
    // margin-bottom: 4px;
    display: flex;
    align-items: center;
    i {
      font-size: 20px;
    }
  }
}
.m-content {
  p {
    padding: 43px 0;
  }
  img {
    width: 100%;
  }
}
.section-bot {
  border-bottom: 20px solid #f5f5f5;
  width: 100%;
  background-color: #fff;
}
.company_info {
  height: 200px;
  padding: 20px 18px;
  box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
  border-radius: 2px;
  border-bottom: 1px solid #ebebec;
  margin-bottom: 20px;
  position: relative;
  background-color: #fff;
  display: flex;
  align-items: center;
  .img {
    border: 1px solid rgba(204, 204, 204, 0.4);
    width: 158px;
    height: 158px;
    float: left;
    @include clearfix;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.company_info .info {
  float: left;

  @include clearfix;

  margin-left: 20px;

  h3 {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    color: #333;
    padding-bottom: 10px;
    width: 25em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.company_info .btn {
  height: 100%;
  position: absolute;
  top: 20px;
  right: 20px;
}
.int-video {
  width: 750px;
  height: 500px;
  margin: 10px 0;
}
.sidebar-info {
  width: 300px;
  padding: 30px;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
  border-radius: 2px;
  background-color: #fff;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  p {
    font-size: 16px;
    color: rgb(0, 0, 0);
    margin-bottom: 20px;
    text-align: left;
    &:first-child,
    &:last-child {
      margin-bottom: 0;
    }
    span {
      font-size: 16px;
      color: rgb(0, 0, 0);
    }
  }
}
</style>
